import { render, staticRenderFns } from "./GrnCreatereturn.vue?vue&type=template&id=76aa3878&scoped=true&"
import script from "./GrnCreatereturn.vue?vue&type=script&lang=js&"
export * from "./GrnCreatereturn.vue?vue&type=script&lang=js&"
import style0 from "./GrnCreatereturn.vue?vue&type=style&index=0&id=76aa3878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aa3878",
  null
  
)

export default component.exports